import "slick-carousel/slick/slick";

jQuery(document).ready(function () {
    
    // if(jQuery(".hero-packshot-slider").attr("data-items") <= 1){
    //     jQuery(".hero .slick-arrow").addClass("hidden");
    // }

    jQuery(".hero-packshot-slider").on('init', function(event, slick){
        if(jQuery(".hero-packshot-slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".hero .slick-arrow").addClass("hidden");
        }
    });

    jQuery(".hero-packshot-slider").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
            var decl = currentSlide - nextSlide;
            var current = jQuery(slick.$slides.get(currentSlide));
            if (decl == 1 || decl == (slick.slideCount - 1) * -1) {
                current.addClass("exit-right");
            } else {
                current.addClass("exit-left");
            }
        }
    );

    jQuery(".hero-packshot-slider").on(
        "afterChange",
        function (event, slick, currentSlide) {
            var slide = jQuery(this).find(".slick-slide");
            slide.removeClass("exit-right exit-left");
        }
    );

    if (jQuery(".hero-packshot-slider").hasClass("slick-initialized")) {
        return;
    } else {
        jQuery(".hero-packshot-slider").slick({
            arrows: false,
            asNavFor: jQuery(".hero-background-slider"),
            dots: true,
            adaptiveHeight: false,
            fade: false,
            speed: 1000
        });
        setTimeout(function () {
            jQuery(".hero-packshot-slider").addClass("init");
        }, 100);
    }
});
